import { render, staticRenderFns } from "./agenda_single.vue?vue&type=template&id=25ca8a25&"
import script from "./agenda_single.vue?vue&type=script&lang=js&"
export * from "./agenda_single.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports